<template>
  <details
    :id="module.id"
    class="faq-item"
    :style="faqElStyles"
    :open="forceOpen"
  >
    <summary
      class="headline"
      :style="headerElStyles"
      :class="parentModule.config.general.showUnderline ? '-underline' : ''"
    >
      <div
        class="headline-text"
        :style="headerTextElStyles"
        v-html="module.config.header.text"
      ></div>

      <template v-if="parentModule.config.general.iconType.value === 'faqMath'">
        <span class="icon -open">
          <Icon icon="fa6-solid:plus" data-icon="fa6-solid:plus" />
        </span>
        <span class="icon -close">
          <Icon icon="fa6-solid:minus" data-icon="fa6-solid:minus" />
        </span>
      </template>
      <template
        v-if="parentModule.config.general.iconType.value === 'faqArrows'"
      >
        <span class="icon -open">
          <Icon icon="fa6-solid:angle-down" data-icon="fa6-solid:angle-down" />
        </span>
        <span class="icon -close">
          <Icon icon="fa6-solid:angle-up" data-icon="fa6-solid:angle-up" />
        </span>
      </template>
    </summary>
    <div
      class="text"
      :style="textElStyles"
      v-html="module.config.text.text"
    ></div>
  </details>
</template>

<script>
import faqModule from "./faqDefaultModuleProp.js";
import faqsModule from "../Faqs/faqsDefaultModuleProp.js";
import { Icon } from "@iconify/vue";

export default {
  name: "Faq",
  components: {
    Icon,
  },
  props: {
    module: {
      type: Object,
      default() {
        return faqModule;
      },
    },
    parentModule: {
      type: Object,
      default() {
        return faqsModule;
      },
    },
    forceOpen: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    faqElStyles() {
      const { faqBackgroundColor, corners } = this.parentModule.config.general;

      const styles = {
        borderRadius: corners.value === "round" ? "20px" : "0px",
        backgroundColor: faqBackgroundColor.value,
      };

      return styles;
    },
    headerElStyles() {
      const { textColor } = this.module.config.header;

      const styles = {
        color: textColor.value,
      };
      return styles;
    },
    headerTextElStyles() {
      const { isTextInCaps, textColor } = this.module.config.header;

      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        textAlign: this.parentModule.config.general.textAlign.value,
      };
      return styles;
    },
    textElStyles() {
      const { textColor } = this.module.config.text;

      const styles = {
        color: textColor.value,
        textAlign: this.parentModule.config.general.textAlign.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.faq-item {
  width: 100%;

  --faq-padding: 24px;

  padding: var(--faq-padding);

  ::marker {
    content: ""; // hides browser default arrow of summary
  }

  ::-webkit-details-marker {
    display: none; // hides browser default arrow in Safari
  }
}

.headline {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  hyphens: auto;

  @include font-family("heading");
  @include scale-fonts("heading-3");
  @include setup-richtext;

  &.-underline {
    padding-bottom: var(--faq-padding);
    border-bottom: 1px solid;
  }
}

.headline-text {
  width: 100%;
}

.text {
  padding-top: var(--faq-padding);
  padding-right: var(--faq-padding);
  hyphens: auto;
  overflow-wrap: anywhere;

  @include font-family("body");
  @include scale-fonts("body");
  @include setup-richtext;
}

.icon {
  flex-shrink: 0;
  align-self: center;
  padding-left: 3px;
  font-size: 18px;

  @include mobile {
    font-size: 16px;
  }
}

// toggle icon visibility with [open] state of summary element
.icon.-open {
  display: flex;
}

[open] .icon.-open {
  display: none;
}

.icon.-close {
  display: none;
}

[open] .icon.-close {
  display: flex;
}
</style>
